module.exports = __webpack_public_path__ + "img/icon-implantation-06.165e4b1b.svg";